$(document).ready(function() {
    let link = "";
    let isRuLocale = !(window.location.pathname.search('^/(ru$|ru/)') === -1);
    const texts = {
        'edition': (isRuLocale ? 'Выбрать издание' : 'Select game edition'),
        'platform': (isRuLocale ? 'Выбрать платформу' : 'Select platform'),
    };
    $(document).on('click', '.js-preorder-steam-button', function(e) {
        if (!((e.target).closest('.js-preorder-bonus'))) {
            $('.js-select-platform').removeClass('active');
            $('.js-select-edition').addClass('active');
            $('.js-preorder-tab-platform').removeClass('active');
            $('.js-preorder-tab-edition').addClass('active');
            $('.js-preorder-tab-platform').addClass('first-chosen');
            $('.js-select-bottom').addClass('show');
            $('.b-pre-order-main__select-title').text(texts.edition);
            $('.js-select-edition').addClass('steam');
            $('.js-select-edition').removeClass('gog');
            $('.js-select-edition').removeClass('egs');
            $('.b-pre-order-main__title').html('Get the game');
            $('.b-pre-order-main').addClass('platform-selected');
            $('.js-consoles').addClass('hide');
        }
    });
    $(document).on('click', '.js-preorder-gog-button', function(e) {
        if (!((e.target).closest('.js-preorder-bonus'))) {
            $('.js-select-platform').removeClass('active');
            $('.js-select-edition').addClass('active');
            $('.js-preorder-tab-platform').removeClass('active');
            $('.js-preorder-tab-edition').addClass('active');
            $('.js-preorder-tab-platform').addClass('first-chosen');
            $('.js-select-bottom').addClass('show');
            $('.b-pre-order-main__select-title').text(texts.edition);
            $('.js-select-edition').removeClass('steam');
            $('.js-select-edition').addClass('gog');
            $('.js-select-edition').removeClass('egs');
            $('.b-pre-order-main__title').html('Get the game');
            $('.b-pre-order-main').addClass('platform-selected');
            $('.js-consoles').addClass('hide');
        }
    });
    $(document).on('click', '.js-preorder-egs-button', function(e) {
        if (!((e.target).closest('.js-preorder-bonus'))) {
            $('.js-select-platform').removeClass('active');
            $('.js-select-edition').addClass('active');
            $('.js-preorder-tab-platform').removeClass('active');
            $('.js-preorder-tab-edition').addClass('active');
            $('.js-preorder-tab-platform').addClass('first-chosen');
            $('.js-select-bottom').addClass('show');
            $('.b-pre-order-main__select-title').text(texts.edition);
            $('.js-select-edition').removeClass('steam');
            $('.js-select-edition').removeClass('gog');
            $('.js-select-edition').addClass('egs');
            $('.b-pre-order-main__title').html('Get the game');
            $('.b-pre-order-main').addClass('platform-selected');
            $('.js-consoles').addClass('hide');
        }
    });
    $(document).on('click', '.js-select-back', function() {
        $('.js-select-edition').removeClass('active');
        $('.js-select-platform').addClass('active');
        $('.js-preorder-tab-platform').addClass('active');
        $('.js-preorder-tab-edition').removeClass('active');
        $('.js-preorder-tab-platform').removeClass('first-chosen');
        $('.js-preorder-content').removeClass('active');
        $('.js-preorder-content-original').addClass('active');
        $('.js-preorder-button').removeClass('active');
        $('.js-select-bottom').removeClass('show');
        $('.js-select-link').removeClass('show');
        $('.b-pre-order-main__select-title').text(texts.platform);
        $('.js-select-edition').removeClass('chosen');
        link = "";
        $('.js-select-link').attr('href', link);
        $('.b-pre-order-main__title').html('Now <span>available</span>');
        $('.b-pre-order-main').removeClass('platform-selected');
        $('.b-pre-order-main').removeClass('edition-selected');
        $('.js-consoles').removeClass('hide');
    });
    $(document).on('click', '.js-preorder-core-button', function() {
        $('.js-preorder-content').removeClass('active');
        if ($(window).width() < 1024) {
            $('.js-preorder-content-original').addClass('active');
        }
        $('.js-preorder-content-core').addClass('active');
        $('.js-preorder-button').removeClass('active');
        $(this).addClass('active');
        $('.js-select-edition').addClass('chosen');
        $('.b-pre-order-main').addClass('edition-selected');
        if ($('.js-select-edition').hasClass('steam')) {
            link = links.steam.core;
        } else if ($('.js-select-edition').hasClass('gog')) {
            link = links.gog.core;
        } else if ($('.js-select-edition').hasClass('egs')) {
            link = links.egs.core;
        } 
        $('.js-select-link').attr('href', link);
        $('.js-select-link').addClass('show');
    });
    $(document).on('click', '.js-preorder-commander-button', function() {
        $('.js-preorder-content').removeClass('active');
        if ($(window).width() < 1024) {
            $('.js-preorder-content-original').addClass('active');
        }
        $('.js-preorder-content-commander').addClass('active');
        $('.js-preorder-button').removeClass('active');
        $(this).addClass('active');
        $('.js-select-edition').addClass('chosen');
        $('.b-pre-order-main').addClass('edition-selected');
        if ($('.js-select-edition').hasClass('steam')) {
            link = links.steam.commander;
        } else if ($('.js-select-edition').hasClass('gog')) {
            link = links.gog.commander;
        } else if ($('.js-select-edition').hasClass('egs')) {
            link = links.egs.commander;
        } 
        $('.js-select-link').attr('href', link);
        $('.js-select-link').addClass('show');
    });
    $(document).on('click', '.js-preorder-mythic-button', function() {
        $('.js-preorder-content').removeClass('active');
        if ($(window).width() < 1024) {
            $('.js-preorder-content-original').addClass('active');
        }
        $('.js-preorder-content-mythic').addClass('active');
        $('.js-preorder-button').removeClass('active');
        $(this).addClass('active');
        $('.js-select-edition').addClass('chosen');
        $('.b-pre-order-main').addClass('edition-selected');
        if ($('.js-select-edition').hasClass('steam')) {
            link = links.steam.mythic;
        } else if ($('.js-select-edition').hasClass('gog')) {
            link = links.gog.mythic;
        } else if ($('.js-select-edition').hasClass('egs')) {
            link = links.egs.mythic;
        } 
        $('.js-select-link').attr('href', link);
        $('.js-select-link').addClass('show');
    });
});


// WEBPACK FOOTER //
// ./src/js/pages/main/tabs.js